import Divider from "@able/react/dist/Divider";
import { PropsWithChildren } from "react";
import DataActions, { DataActionsProps } from "../../../DataActions/DataActions";

export type TableActionsProps = PropsWithChildren & Partial<DataActionsProps>;

const TableActions = ({ children, ...rest }: TableActionsProps) => {

    const { developmentUrl } = rest;

    return (<>
        <div className="ted-ui-TableActions">
            <DataActions {...rest as DataActionsProps} developmentUrl={developmentUrl}>
                {children}
            </DataActions>
        </div>
        <Divider />
    </>);
};

TableActions.displayName = 'TableActions';

export default TableActions;